export interface AssetCategoryListItem {
  id: string;
  name: string;
  description: string | null;
  is_active: boolean;
  created_at: string;
  features?: {
    id: string;
    feature_name: string;
    feature_type: 'text' | 'number' | 'boolean' | 'select';
    description: string | null;
    options: string[] | null;
    is_required: boolean;
    is_active: boolean;
  }[];
  assets?: { id: string }[];
  templates?: { id: string }[];
  roomTypes?: { id: string; key: string; name: string }[];
}

export const fetchAllAssetCategories = async (
  includeInactive = true,
): Promise<AssetCategoryListItem[]> => {
  const params = new URLSearchParams({
    include_inactive: String(includeInactive),
    limit: '500',
    sortBy: 'name',
    sortOrder: 'ASC',
  });
  const response = await fetch(`/api/asset-categories?${params}`);
  if (!response.ok) throw new Error(`Failed to load categories (${response.status})`);
  const data = await response.json();
  const items: unknown[] = Array.isArray(data) ? data : (data.data || []);
  return items.filter(isAssetCategoryListItem);
};

const isAssetCategoryListItem = (value: unknown): value is AssetCategoryListItem => {
  if (!value || typeof value !== 'object') return false;
  const item = value as Record<string, unknown>;
  return typeof item.id === 'string'
    && typeof item.name === 'string'
    && (typeof item.description === 'string' || item.description === null)
    && typeof item.is_active === 'boolean'
    && typeof item.created_at === 'string';
};
